import styled from "styled-components";

export function MyPage(){
    return(
        <MyPageContainer>

        </MyPageContainer>
    );
}


// 두더치 로고 누르면 /main으로 

const MyPageContainer=styled.div`
    width:100%;
    height:700px;
    background-color:red;
`;
